<script>
  import contratoServico from '../servico';
  import Paginacao from '~componentes/Paginacao.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import $ from 'jquery';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import Radio from '~componentes/Radio.vue';
  import projetoServico from '~modulos/projeto/servico';
  import { checkbox } from 'vue-strap';
  import ModalLiberarContrato from '~componentes/ModalLiberarContrato.vue';
  
  export default {
    components: { Paginacao, ModalArquivosSolicitacao, ModalLiberarContrato, ModalMensagem, Radio, checkbox },
    data() {
      return {
        contratos: [],
        carregando: false,
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        animated: true,
        modalArquivos: false,
        modalMensagem: false,
        solicitacaoSelecionada: null,
        configuracao: this.$storage.configuracao(),
        filtros: this.camposFiltros(),
        projetos: [],
        modalLiberarContrato: false,
        salvandoLiberacao: false,
      }
    },
    methods: {
      alinhacheckbox() {
        var totalckb = document.querySelectorAll('.ckbselecionado').length;

        for (var i = 0; i < totalckb; i++) {
          document.querySelectorAll('.ckbselecionado')[i].firstElementChild.setAttribute('style', 'position: relative');
        }  
      },
      lista(pagina = 1) {
        this.carregando = true;
        this.$route.params.filtrosBag = pagina;
        
        return contratoServico
          .lista(pagina, this.filtros)
          .then(dados => {
            this.carregando = false;

            this.contratos = dados.registros;
            this.totalRegistros = dados.totalRegistros;
            this.totalPaginas = dados.totalPaginas;
            this.registrosPorPagina = dados.registrosPorPagina;

            this.alinhacheckbox();
            setTimeout(() => { this.alinhacheckbox(); }, 1000);
          });
      },
      listaDeProjetos() {
        return projetoServico
          .listaTodosProjetos()
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      camposFiltros() {
        return {
          idProjeto: '',
          solicitacaoWeb: '',
          porNivel1: 0,
          porNivel2: 0,
          porNivel3: 0,
          porContrato: 0,
          tipoContrato: 0,
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val('0');
          $('#projeto').trigger('change.select2');
        });

        this.lista();
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
      },
      mostrarModalLiberarContrato() {
        var mostrar = false;

        for (var i = 0; i < this.contratos.length; i++) {
          if (this.contratos[i].selecionado === "1") {
            mostrar = true;
            break;
          }
        }

        if (mostrar) {
          this.modalLiberarContrato = mostrar;
        }
        else {
          this.$swal(
            '',
            'É necessário selecionar pelo menos um contrato para liberação. ',
            'info'
          );
        }
      },
      modalLiberarContratoFechado() {
        this.animated = false;
        this.modalLiberarContrato = false;
      },
      liberar() {
        $('#liberar').button('loading');
        this.modalLiberarContrato = false;
        
        return contratoServico
          .liberarContratos(this.contratos)
          .then(() => {
            $('#liberar').button('reset');

            toastr.success(`Contratos selecionados liberados com sucesso.`);
            $('body').removeClass('modal-open');

            if (this.$route.params.filtrosBag) {
              this.pagina = this.$route.params.filtrosBag;
              this.lista(this.pagina);
              this.$refs.paginacao.handlePageSelected(this.pagina - 1);
            }
            else
              this.lista();
          })
          .catch(erro => {
            $('#liberar').button('reset');

            this.$mensagemErro(erro, 'Erro ao tentar liberar os contratos, ou usuário não possui permissão.');
          });
      },
    },
    created() {
      this.$root.botaoRetrocederMostrar = false;
    },
    mounted() {
      this.$root.botaoAcaoMostrar = false;
      this.$root.tituloDaPagina = 'Liberação de contratos - Lista';
      this.listaDeProjetos();
      this.modalLiberarContrato = false;

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function (e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
      });

      if (this.$route.params.tipo) {
        this.filtros.tipoContrato = this.$route.params.tipo; 
      }

      if (this.$route.params.filtrosBag) {
        this.pagina = this.$route.params.filtrosBag;
        this.lista(this.pagina);
        this.$refs.paginacao.handlePageSelected(this.pagina - 1);
      }
      else
        this.lista();
    }
  }
</script>

<style scoped>
  .liberacao {
    font-size: 1.20em;
    color: #1d9d74;
    margin-right: 3px;
  }
</style>

<template>
  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada : ''"
                                tipo="bolsa"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoBolsa : ''"
                    tipo="SolBolsa"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <modal-liberar-contrato :mostrar="modalLiberarContrato"
                            :salvando="salvandoLiberacao"
                            @fechado="modalLiberarContratoFechado"
                            @liberar="liberar">
    </modal-liberar-contrato>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>

          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select id="projeto"
                          class="form-control"
                          v-model="filtros.idProjeto">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">

              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label" for="numero">Solicitação contrato</label>

                  <input type="text"
                         class="form-control"
                         id="numero"
                         v-model="filtros.solicitacaoWeb"
                         v-numero>
                </div>
              </div>

              <label class="control-label block">Liberação pendente</label>

              <div class="col-xs-1">
                <div class="form-group">
                  <div class="checkbox">
                    <checkbox v-model="filtros.porNivel1" value="1" type="success" true-value="1" false-value="0">
                      Nível 1
                    </checkbox>
                  </div>
                </div>
              </div>

              <div class="col-xs-1">
                <div class="form-group">
                  <div class="checkbox">
                    <checkbox v-model="filtros.porNivel2" value="1" type="success" true-value="1" false-value="0">
                      Nível 2
                    </checkbox>
                  </div>
                </div>
              </div>

              <div class="col-xs-1">
                <div class="form-group">
                  <div class="checkbox">
                    <checkbox v-model="filtros.porNivel3" value="1" type="success" true-value="1" false-value="0">
                      Nível 3
                    </checkbox>
                  </div>
                </div>
              </div>

              <div class="col-xs-2">
                <div class="form-group">
                  <div class="checkbox">
                    <checkbox v-model="filtros.porContrato" value="1" type="success" true-value="1" false-value="0">
                      Liberação contrato
                    </checkbox>
                  </div>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-success no-margins" @click="lista">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-eraser"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">
            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                  <tr>
                    <th>Solicitação contrato</th>
                    <th>Vigência início</th>
                    <th>Contratada</th>
                    <th>Projeto</th>
                    <th>Complemento contrato</th>
                    <th class="text-center">Nível 1</th>
                    <th class="text-center">Nível 2</th>
                    <th class="text-center">Nível 3</th>
                    <th class="text-center">Liberação contrato</th>
                    <th>Liberar</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(contrato, index) in contratos">
                    <td>{{ contrato.idSolicitacaoBolsa }}</td>
                    <td>{{ contrato.dataContrato | formatarData }}</td>
                    <td>{{ contrato.contratado || '---' }}</td>
                    <td>{{ contrato.nomeProjeto }}</td>
                    <td>{{ contrato.complementoContrato || '---' }}</td>
                    <td class="text-center"><i v-if="contrato.n1" class="fa fa-check-circle liberacao" v-tooltip="'Liberado'" aria-hidden="true"></i></td>
                    <td class="text-center"><i v-if="contrato.n2" class="fa fa-check-circle liberacao" v-tooltip="'Liberado'" aria-hidden="true"></i></td>
                    <td class="text-center"><i v-if="contrato.n3" class="fa fa-check-circle liberacao" v-tooltip="'Liberado'" aria-hidden="true"></i></td>
                    <td class="text-center"><i v-if="contrato.cl" class="fa fa-check-circle liberacao" v-tooltip="'Liberado'" aria-hidden="true"></i></td>
                    <td>
                      <checkbox class="ckbselecionado" v-model="contrato.selecionado" :disabled="contrato.disabledSelecionado" value="1" type="success" true-value="1" false-value="0">

                      </checkbox>
                    </td>
                    <td>
                      <router-link class="btn btn-primary btn-xs"
                                   active-class=""
                                   v-tooltip="'Visualizar e liberar'"
                                   :to="{ name: 'contrato.relatorio', params: { id: contrato.idContratoCrypt, filtrosBag: $route.params.filtrosBag, tipo : $route.params.tipo } }">
                        <i class="fa fa-file-text-o"></i>
                      </router-link>

                      <button type="button"
                              class="btn btn-info btn-xs"
                              v-tooltip="'Listar ou adicionar arquivos'"
                              @click="mostrarModalArquivos(contrato.idSolicitacaoBolsa)"
                              v-if="configuracao.usarArquivosSolicitacaoBolsa">
                        <i class="fa fa-archive"></i>
                      </button>

                      <button type="button"
                              class="btn btn-success btn-xs"
                              v-tooltip="'Ler\Enviar mensagem'"
                              @click="mostrarModalMensagem(contrato)"
                              v-if="(!configuracao.naoUtilizarMensageria && !configuracao.desativarMensageriaSolBolsa)">
                        <i class="fa fa-comment"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="carregando">
                    <td colspan="11">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row">
              <div class="text-right">

                <button class="btn btn-primary"
                        style="margin-right: 70px;"
                        v-tooltip="'Liberar contratos'"
                        @click="mostrarModalLiberarContrato">
                  <i class="fa fa-check"></i> Liberar contratos
                </button>

              </div>
            </div>

            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true"
                       ref="paginacao">
            </paginacao>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/contrato/componentes/Lista.vue